import EMAIL_ICON from './assets/images/email-icon.svg';
import PASSWORD_ICON from './assets/images/password-icon.svg';
import PASSWORD from './assets/images/password.svg';
import MICROSOFT_ICON from './assets/images/microsoft-logo.png';
import PALOALTO_ICON from './assets/images/paloalto-logo.png';
import MOUSER_ICON from './assets/images/mouser-electronic-logo.png';
import POWER_ICON from './assets/images/power-integration-logo.png';
import MAIL_ICON from './assets/images/mail.svg';
import RESET_PASSWORD_ICON from './assets/images/reset-password.svg';
import USER_ICON  from './assets/images/user-iocn.png';
import ARROW_ICON from './assets/images/arrow.svg'
import ERROR_ICON  from './assets/images/error.png';
import OPAL_ICON from './assets/images/opal_favicon.ico';
import TOOLTIP from './assets/images/tooltip.svg';
import LOGO from './assets/images/NEW_Logo.svg';
import LOGO_AA from './assets/images/NEW_Logo_AA.svg';
import LOGO_LOGIN from './assets/images/NEW_LOGIN_Logo.svg';
import OPAL_LOGO from './assets/images/Opal.svg';
const  icons = { 
        EMAIL_ICON ,PASSWORD_ICON,PASSWORD, MICROSOFT_ICON, PALOALTO_ICON,
         MOUSER_ICON, POWER_ICON ,MAIL_ICON, RESET_PASSWORD_ICON,
         USER_ICON,ARROW_ICON,ERROR_ICON,TOOLTIP,LOGO,LOGO_AA,LOGO_LOGIN,
         OPAL_ICON,OPAL_LOGO
}
export default icons;

